import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const opts = { withCredentials: true };

export const useBookings = (user) => {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/admin/bookings`, opts);
      setBookings(r.data);
    } catch (e) {
      if (e.response?.status !== 401) return toast.error("Impossible de charger les réservations");
      try {
        await axios.post(`${API}/auth/refresh`, {}, opts);
        const r = await axios.get(`${API}/admin/bookings`, opts);
        setBookings(r.data);
      } catch {
        navigate("/admin/login");
      }
    }
  }, [navigate]);

  useEffect(() => {
    if (user) load();
  }, [user, load]);

  const setStatus = async (b, status) => {
    try {
      await axios.patch(`${API}/admin/bookings/${b._id}`, { status }, opts);
      toast.success(status === "annule" ? "Rendez-vous annulé" : "Rendez-vous confirmé");
      load();
    } catch {
      toast.error("Action impossible");
    }
  };

  const remove = async (b) => {
    if (!window.confirm(`Supprimer le rendez-vous de ${b.name} ?`)) return;
    try {
      await axios.delete(`${API}/admin/bookings/${b._id}`, opts);
      toast.success("Réservation supprimée");
      load();
    } catch {
      toast.error("Suppression impossible");
    }
  };

  return { bookings, setStatus, remove };
};
